// extracted by mini-css-extract-plugin
export default {"block-root":"VI_bgJavrn3uXP6R6t10","block-form":"kJJW33TjRzq5nGWbHoVA","copy":"WvJrK3U4hxkUavy6OCAQ"};